/* eslint-disable import/no-anonymous-default-export */

import apiCall from "./apiCall";

export default {
  async addBank(data) {
    return await apiCall("bank/add", data);
  },
  async deleteBank(data){
    return await apiCall("banking/bank/delete_bank", data);
  },
  async updateBank(data) {
    return await apiCall("banking/bank/update_bank", data);
  },
  async addCheque(data) {
    return await apiCall("banking/checking/new_cheque", data);
  },
  async listBanks() {
    let data = { source: "Web" };
    let response = await apiCall("bank/list", data);
    return response;
  },
  async listRecentTransactions() {
    let response = await apiCall("banking/checking/recent_transactions", []);
    return response;
  },

  async fetchCheckingRecords(data){
    return await apiCall("banking/checking/list", data);
  },

  async createCheckingEntry(data){
    return await apiCall("banking/checking/new_cheque", data);
  },
  async fetchCheckingStat(){
    return await apiCall("banking/checking/stats", {});
  }
};
